import axios from "@/axios/axios";

const actions = {
  async GET_DEVICES_VALUES_RANGE(context){
    context.commit('SET_RAGE_DEVICES_VALUES_MONTH');
    try{
      let {data} = await axios.get('u_device_with_values', {
        params: {
          account_number: context.rootGetters['appUser/client/aparts/selected'].account_number,
          from: context.getters.rangeDevicesValuesMonth.from,
          to: context.getters.rangeDevicesValuesMonth.to
        }
      });
      if(data === 'apart is not passed'){
        context.commit('SET_DEVICES_VALUES', []);
      }
      else{
        context.commit('SET_DEVICES_VALUES', data.filter(device => context.getters.displayDevices[device.type] !== false));
      }
    }
    catch(e){
      console.error(e);
      context.commit('SET_DEVICES_VALUES', []);
    }
  },
  async GET_DEVICES_VALUES(context, payload){
    let withLoading = payload ? payload.loading : true;

    if(withLoading){
      context.commit('SET_LOADING', true);
    }

    try{
      await context.dispatch('GET_DEVICES_DISPLAY');

      let {data: devices} = await axios.get('u_device_with_values', {
        params: {
          account_number: context.rootGetters['appUser/client/aparts/selected'].account_number,
        }
      });

      devices = devices.filter(device => context.getters.displayDevices[device.type] !== false);

      devices.forEach(device => {
        if(context.rootGetters['appUser/client/aparts/selected'].type_apart === 1 && context.rootGetters['appUser/client/aparts/selectedBuildingsId'] === 6){
          if(device.type === 3){
            device.showVisualNight = true;
          }
        }
        if([13, 69, 71, 72, 73].includes(context.rootGetters['appUser/client/aparts/selectedBuildingsId'])){
          if(device.type === 2){
            device.preventValidate = true;
            device.showVisualHeater = true;
          }
        }
      });

      if(devices === 'apart is not passed'){
        context.commit('SET_BODY_TO_SEND_VALUES', {devices: [], settings: []});
      }
      else{
        let {data: settings} = await axios.get('u_device_values_settings', {
          params: {
            apartments_id: context.rootGetters['appUser/client/aparts/selected'].id
          }
        });

        settings = Object.values(settings).map(v => Number(v));

        context.commit('SET_BODY_TO_SEND_VALUES', {devices: devices, settings: settings});
      }
    }
    catch(e){
      console.error(e);
      context.commit('SET_BODY_TO_SEND_VALUES', {devices: [], settings: []});
    }
    finally {
      context.commit('SET_LOADING', false);
    }
  },
  UPDATE_RAGE_DEVICES_VALUES_MONTH(context, payload){
    context.commit('SET_RAGE_DEVICES_VALUES_MONTH', payload);
    context.dispatch('GET_DEVICES_VALUES_RANGE');
  },
  SEND_DEVICE_VALUE(context, payload){
    let body = Object.assign(payload, {
      account_number: context.rootGetters['appUser/client/aparts/selected'].account_number
    });

    return axios.post('u_devices_value', body);
  },
  async GET_DEVICES_DISPLAY(context){
    let {data: displayDevices} = await axios.get('u_device_display_settings', {
      params: {
        apartments_id: context.rootGetters['appUser/client/aparts/selected'].id
      }
    });
    context.commit('SET_DISPLAY_DEVICES', displayDevices);
    return true;
  }
};

export default actions;
